import React from 'react';
import DataTable from '../../../../components/DataTable';
import cityImport from '../../../../ExcelFiles/city.xlsx';

const SupportCity = () => {

    let columns = ["name", "state", "country"]
    let headers = ["Name", "State", "Country"];
    let excelheader = ["name", "state"]
    let addform = [
        { 'name': 'name', 'label': 'Name', 'type': 'short-text', 'addVali': 'required|min:6' },
        { 'name': 'state', 'label': 'State', 'type': 'dropdown', 'required': true, 'url': 'state/' },
    ]

    return (
        <DataTable
            url="city/"
            column={columns}
            header={headers}
            title='Cities'
            addform={addform}
            excelheader={excelheader}
            excelurl="city-import/"
            successMessage="Added Successfully"
            filePath={cityImport}
            filename="Cities.xlsx"
        />
    );
};

export default SupportCity;